<template>
    <div class="container let-space-1">
        <div class="card card-body mb-2">
            <div class="d-flex">
                <span>
                    <i class="fas fa-id-card icon-size text-primary pr-2"></i>
                </span>
                <span>本人確認</span>
                <div v-if="status == 2"  class="text-right ml-auto text-danger">
                    <i class="fas fa-exclamation-circle icon-size text-danger"></i>
                    <span><small>未完了 </small></span>
                </div>
                <div v-if="status == 0" class="text-right ml-auto text-warning-cust">
                    <i class="fas fa-exclamation-circle icon-size"></i>
                    <span><small>依頼済 </small></span>
                </div>
                <div v-if="status == 1" class="text-right ml-auto text-success">
                    <i class="far fa-check-circle icon-size"></i>
                    <span><small>承認済 </small></span>
                </div>
            </div>
            <div v-if="status != 2">
                <div>
                    <hr>
                    <div>
                        <small> 依頼日：{{item.created_at | dformatf }} </small>
                    </div>
                    <div>
                        <small v-if="item.bug_date" :class="{'text-danger':hasBug}"> 指摘日：{{item.bug_date | dformatf }} </small>
                    </div>
                    <div>
                        <small v-if="item.approval_date"> 承認日：{{item.approval_date | dformatf }} </small>
                    </div>
                    <hr>
                </div>
                <div class="justify-content-between d-flex">
                    <span @click="btnOk"> <i class="far fa-check-circle"></i> 承認 </span>
                    <!-- <span @click="openPrivateInfo(item.user_id)"> <i class="far fa-user-circle"></i> 詳細 </span> -->
                    <span @click="btnBug"> <i class="fas fa-bug"></i> 不備 </span>
                </div>
            </div>
        </div>

        <!-- 不備確認画面 -->
        <identity-bug ref="bug"></identity-bug>
    </div>
</template>

<script>
    import IdentityBug from './IdentityBug'
    import {mapGetters} from 'vuex'
    import {isAfter} from 'pages/commons/form/comFunc'

    export default {
        components: {
            IdentityBug
        },
        props: {
            item: {
                type: Object
            }
        },
        computed: {
            hasBug () {
                if (this.item.bug_date == null) {
                    return false
                } else {
                    if (this.item.approval_date == null) {
                        return true
                    } else {
                        return isAfter(this.item.bug_date, this.item.approval_date)
                    }
                }
            },
            status () {
                if (this.item == null) {
                    return 2
                }
                return this.item.status
            }
        },
        methods: {
            btnOk () {
                this.$parent.showMsg('承認を行いますか？', 2, 'ident-ok')
            },
            btnBug () {
                this.$refs.bug.openThis()
            },
            openPrivateInfo (userId) {
                this.$parent.openPrivateInfo(userId)
            },
        }
        
    }

</script>

<style lang="stylus" scoped>

</style>
